import {
  HUBSPOT_ACCESS_TOKEN,
  HUBSPOT_ACCOUNTS,
  HUBSPOT_LISTS,
  HUBSPOT_OAUTH_URL,
  HUBSPOT_REVOKE_ACCESS_TOKEN,
  HUBSPOT_REVOKE_TOKEN,
} from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';

export default class HubspotController extends AuthenticatedController {
  static async getOauthUrl(facebookPageId: number) {
    return super.get(HUBSPOT_OAUTH_URL, {
      facebook_page_id: facebookPageId,
    });
  }

  static async getAccounts(facebookPageId: number) {
    return super.get(HUBSPOT_ACCOUNTS, {
      facebook_page_id: facebookPageId,
    });
  }

  static async revokeToken(tokenId: number) {
    return super.post(HUBSPOT_REVOKE_TOKEN, {
      token_id: tokenId,
    });
  }

  static async revokeAccessToken(tokenId: number) {
    const path = HUBSPOT_REVOKE_ACCESS_TOKEN(tokenId);
    return super.post(path);
  }

  static async updateAccessToken(
    facebookPageId: number,
    tokenId: number,
    acceesToken: string,
  ) {
    return super.patch(HUBSPOT_ACCESS_TOKEN(tokenId), {
      access_token: acceesToken,
      facebook_page_id: facebookPageId,
    });
  }

  static async getLists(facebookPageId, account, force: boolean = false) {
    return super.get(HUBSPOT_LISTS, {
      facebook_page_id: facebookPageId,
      token_id: account.id,
      token_type: account.type,
      force,
    });
  }
}
